<template>
  <v-app class="app-background">
    <v-main>
      <NavbarComponent v-if="!isPublicPage" />
      <router-view />
      <NotificacaoComponent />
      <AlertComponent />
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import NavbarComponent from "./shared/components/NavbarComponent.vue";
import NotificacaoComponent from "./shared/components/NotificacaoComponent.vue";
import AlertComponent from "./shared/components/AlertComponent.vue";

const route = useRoute();

const isPublicPage = computed(() => {
  const publicPaths = [
    "/",
    "/login",
    "/auth/cadastro",
    "/auth/recadastro",
    "/integrador/cadastro",
    "/integrador/conclua-cadastro",
    "/cadastro-integradores",
    "/cadastro-integradores/empresa",
  ];
  return publicPaths.includes(route.path);
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app-background {
  background-color: rgb(var(--v-theme-tertiary)) !important;
}
</style>
